import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-66dcfeef")
const _hoisted_1 = { class: "container justify-center d-flex align-center" }
const _hoisted_2 = {
  class: "justify-center half d-flex flex-column",
  style: {"z-index":"1000"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-h2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-uppercase font-weight-black" }, "Hoppermation")
], -1)
const _hoisted_4 = { class: "mt-5 subtitle font-weight-medium text-subtitle" }
const _hoisted_5 = { class: "mt-5" }
const _hoisted_6 = { class: "justify-center half d-flex align-center" }
_popScopeId()

import { getAuth0State, getInstance } from '@/auth'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const authState = getAuth0State()
const auth = getInstance()

const login = (): void => {
  auth.loginWithRedirect()
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_lottie_player = _resolveComponent("lottie-player")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('login.info')), 1),
      _createElementVNode("div", _hoisted_5, [
        (!_unref(authState).isAuthenticated)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              onClick: login,
              color: "primary",
              class: "login-button text-subtitle-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login.button')) + " ➜ ", 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_lottie_player, {
        src: "https://assets8.lottiefiles.com/packages/lf20_u25cckyh.json",
        background: "transparent",
        speed: "0.5",
        class: "lottie-player",
        loop: "",
        autoplay: ""
      })
    ])
  ]))
}
}

})